import { render } from "./GameManager.vue?vue&type=template&id=1401e610"
import script from "./GameManager.vue?vue&type=script&lang=js"
export * from "./GameManager.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__